import React from 'react';
import { IconBase } from '../Base';
export const IconChevronDown = (props) => {
    return (React.createElement(IconBase, { ...props },
        React.createElement("path", { d: "M6.66666 8.33337L10 11.6667L13.3333 8.33337", fill: "none", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round", style: { stroke: 'var(--icon-color)' } })));
};
//# sourceMappingURL=Down.js.map